export default {"src":"/_next/static/media/leftLinePromotionCard.bf0fabdd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};